import React from 'react'
import PropTypes from 'prop-types'

import styles from './styles.scss'

const Welcome = () => {
  return (
    <div className={styles.root}>Hello, I am Welcome</div>
  )
}

Welcome.propTypes = {}

export default Welcome
